import { Flex } from '@chakra-ui/react';
import { rowH } from '../DetailedStatistics';
import EventPoint from './EventPoint';
import { ACTIVITIES } from 'types';

const DetailedRow = ({ data, type }: { type: ACTIVITIES; data: Array<any> }) => {
    return (
        <Flex position="relative" height={rowH} overflow="hidden">
            {data
                ?.slice()
                .reverse()
                .map((item: any, index: number) => (
                    <EventPoint item={item} type={type} key={index} />
                ))}
        </Flex>
    );
};

export default DetailedRow;
